











































import Vue from 'vue'
import HeaderSection from './HeaderSection.vue'
import RangeSlider from '@/common/components/RangeSlider.vue'
import FilterItem from './FilterItem.vue'

export default Vue.extend({
  components: {
    HeaderSection,
    RangeSlider,
    FilterItem
  },
  props: {
    minUnitPrice: {
      type: Number,
      default: 0,
      required: true
    },
    maxUnitPrice: {
      type: Number,
      default: 0,
      required: true
    },
    minThreshold: {
      type: Number,
      default: 0,
      required: true
    },
    maxThreshold: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data(): {
    minRange: number
    maxRange: number
    toggleSection: boolean
    minInputValidate: boolean
    maxInputValidate: boolean
    errorMessage: string
  } {
    return {
      minRange: this.minUnitPrice,
      maxRange: this.maxUnitPrice,
      toggleSection: true,
      minInputValidate: false,
      maxInputValidate: false,
      errorMessage: ''
    }
  },
  computed: {
    resetFilter(): boolean {
      return (
        this.minThreshold == this.minUnitPrice &&
        this.maxThreshold == this.maxUnitPrice
      )
    },
    disableButton(): boolean {
      return this.errorMessage != ''
    },
    minRangeValue: {
      get() {
        return this.minUnitPrice
      },
      set(value: number) {
        this.minRange = value
      }
    },
    maxRangeValue: {
      get() {
        return this.maxUnitPrice
      },
      set(value: number) {
        this.maxRange = value
      }
    }
  },
  watch: {
    minUnitPrice(value: number) {
      if (value === 0) {
        this.minRangeValue = this.minUnitPrice
      }
    },
    resetFilter(value: boolean) {
      if (value){
        this.minRange = this.minRangeValue
        this.maxRange = this.maxRangeValue
      }
    }
  },
  methods: {
    toggleSectionHandler(value: { [key: string]: boolean }) {
      this.toggleSection = value.toggle
      this.maxRange = this.maxRangeValue
      this.minRange = this.minRangeValue
    },
    rangeValuesHandler(value: { [key: string]: number }) {
      this.minRange = value.min
      this.maxRange = value.max
      this.validateInputs()
    },
    minInputValidateHandler(value: boolean) {
      this.minInputValidate = value
      this.validateInputs()
    },
    maxInputValidateHandler(value: boolean) {
      this.maxInputValidate = value
      this.validateInputs()
    },
    validateInputs() {
      let error = ''
      if (this.maxThreshold){
        if (isNaN(this.maxRange) ||
          isNaN(this.minRange) ||
          (this.minInputValidate && this.maxInputValidate)){
          error =  '半角数字で入力してください'
        } else if (this.minRange > this.maxRange ||
          this.maxRange < this.minRange ||
          this.minRange < this.minThreshold ||
          this.maxRange > this.maxThreshold){
          error =  '最小値は最大値より低いです。'
        }
      }
      this.errorMessage = error
    }
  }
})
